import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'
import { initAB } from '@/services/ab'

import '@/assets.v2/css/style.scss'

const tableOfContentsJS = require('@/assets.v2/js/tableOfContents.js')
const { tableOfContentsHighlighting, toggleTableOfContents } = tableOfContentsJS

const headerJS = require('@/assets.v2/js/header.js')
const { header } = headerJS

export function initPagePodcast(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', async function () {
    header()
    tableOfContentsHighlighting()
    toggleTableOfContents()
    initAB()
    Mixpanel.pageView()
  })
}
